var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.3,
    height: 17.3,
    viewBox: "0 0 17.3 17.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-questions",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M8.5,15.938A7.438,7.438,0,1,0,1.063,8.5,7.437,7.437,0,0,0,8.5,15.938ZM8.5,17A8.5,8.5,0,1,0,0,8.5,8.5,8.5,0,0,0,8.5,17Z",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M11.813,10.566h1.4A1.356,1.356,0,0,1,14.66,9.1a1.234,1.234,0,0,1,1.395,1.241c0,.675-.4.985-1.025,1.457A2.42,2.42,0,0,0,13.789,13.9l.008.492h1.389V14.02c0-.763.29-.985,1.073-1.579a2.593,2.593,0,0,0,1.322-2.184c0-1.606-1.356-2.381-2.84-2.381-1.409,0-2.96.688-2.926,2.691Zm1.659,5.861a1,1,0,0,0,1.073.985,1,1,0,1,0,0-1.984,1,1,0,0,0-1.072,1Z",
    transform: "translate(-6.235 -4.156)",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestions);
export default __webpack_public_path__ + "static/media/icon-questions.6302ec209520e9733a21327b029476a8.svg";
export { ForwardRef as ReactComponent };